import { Component, OnInit } from "@angular/core";
import { SeoService } from "../service/seo.service";

@Component({
  selector: "app-pages",
  template: `
  <div  class="!w-screen fixed z-[9999]">
  <app-menu></app-menu></div>
  <div id="container-web" class="!w-screen !h-[100dvh] overflow-scroll relative overflow-x-hidden custom-scroll" style="background: #FCFCFC">
  <div class="bg-transparent !w-screen flex flex-wrap z-[2] absolute">
  <div class="!w-screen min-h-[calc(100dvh-550px)] mt-[148px]">
    <router-outlet></router-outlet></div>
    <app-footer></app-footer>
  </div> 
</div>`,
  styles: [],
  standalone: false,
})
export class PagesComponent implements OnInit {
  constructor(private seo: SeoService) { }

  ngOnInit(): void {
    this.seo.updateSeo();
  }

}
